import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { APIHelperService } from './apiHelper.service';

@Injectable({ providedIn: 'root' })
export class EntrataService {

  constructor(
    private http: HttpClient,
    private apiHelper: APIHelperService
  ) {
    // no-op
  }

  getSources() {
    return this.http.get<any>(this.apiHelper.fillUrl('entrataSources', {}, {}))
      .pipe(map(data => {
        return data;
      }));
  }

  getEventTypes() {
    return this.http.get<any>(this.apiHelper.fillUrl('entrataEventTypes', {}, {}))
      .pipe(map(data => {
        return data;
      }));
  }

  // Used in automation
  getSourcesQuery() {
    return this.http.get<any>(this.apiHelper.fillUrl('entrataSourcesQuery', {}, {}))
      .pipe(map(data => {
        return data;
      }));
  }

  getLeasingAgents() {
    return this.http.get<any>(this.apiHelper.fillUrl('entrataAgents', {}, {}))
      .pipe(map(data => {
        return data;
      }));
  }

  checkEntrataWorkers(id) {
    return this.http.get<any>(this.apiHelper.fillUrl('entrataWorkers', {id: id}, {}))
      .pipe(map(data => {
        return data;
      }));
  }

  getEntrataSourcesAdmin(payload) {
    return this.http.post<any>(this.apiHelper.fillUrl('entrataSource', {id: payload._id}, {}), payload)
      .pipe(map(data => {
        return data;
      }));
  }

  getEntrataAgentsAdmin(payload) {
    return this.http.post<any>(this.apiHelper.fillUrl('entrataAgent', {id: payload._id}, {}), payload)
      .pipe(map(data => {
        return data;
      }));
  }

  verifyAndCreateEntrataIntegration(payload) {
    return this.http.post<any>(this.apiHelper.fillUrl('verifyIntegration', {type: 'entrata'}, {}), payload)
    .pipe(map(data => {
      return data;
    }));
  }
}
